<header>
  @if (previewContentType()) {
    <div class="scenic-card preview-card" [class.shadow]="!mode()">
      <div class="thumbnail" [class.workout-chart]="showWorkoutChart()">
        @if (preview().thumbnailUrl) {
          <img
            [src]="preview().thumbnailUrl"
            [alt]="'content_creation_preview.thumbnail_alt' | translate"
          />
        } @else if (showWorkoutChart()) {
          <app-workout-preview-chart
            [sections]="workoutSections()"
            [mode]="createContentService.workoutMode()"
          />
        } @else if (hasCoordinatesForGpsOnly()) {
          <div class="map">
            <div
              style="min-height: 280px"
              leaflet
              [leafletOptions]="leafletService.options()"
              [leafletLayers]="leafletService.layers()"
              [leafletFitBounds]="leafletService.fitBounds()"
              [leafletFitBoundsOptions]="leafletService.fitBoundsOptions()"
              (leafletMapReady)="leafletService.onMapReady($event)"
            ></div>
          </div>
        } @else {
          <kin-icon [name]="icon || 'picture'" [size]="72" [color]="neutral300" />
        }
      </div>
      <div class="preview-bottom-card">
        <div class="infos-container">
          <div class="title">{{ preview().title || '-' }}</div>
          <div class="infos">
            <div class="info">
              <span class="difficulty-dot" [style.background]="workoutDifficultyColor()"></span>
              <p>
                {{
                  workoutDifficulty()
                    ? ('content_creation_preview.difficulty_level.' + workoutDifficulty()
                      | translate)
                    : '-'
                }}
              </p>
            </div>
            <div class="info">
              <kin-icon name="like_fill" color="#FFC947" [size]="16" />
              <p>{{ preview().likesCount ?? '-' }}</p>
            </div>
          </div>
        </div>
        <div class="datas-container">
          @for (chip of chips(); track chip.data) {
            <app-chip
              [icon]="chip.icon"
              [text]="chip.text"
              [formatText]="chip.data !== 'workoutMode'"
              [iconColor]="colorService.brandSecondary400()"
              [backgroundColor]="colorService.brandSecondary100()"
            />
          }
        </div>
      </div>
    </div>
  }
  @if (showData()) {
    @if (mode() === 'creation') {
      <p class="resume">{{ 'content_creation_preview.summary' | translate }}</p>
    }
    <ul>
      @if (previewContentType() !== 'workout' && mode() === 'creation') {
        <li>
          <kin-icon name="save" color="#7E8184" [size]="16" />
          <label>{{ 'content_creation_preview.record_date' | translate }}</label>
          <p class="value">{{ (preview().recordDate | date) || '-' }}</p>
        </li>
      }
      <li>
        <kin-icon name="upload" color="#7E8184" [size]="16" />
        <label>{{ 'content_creation_preview.upload_date' | translate }}</label>
        <p class="value">{{ (preview().uploadDate | date) || '-' }}</p>
      </li>

      @if (previewContentType() === 'scenic' && mode() === 'creation') {
        <li>
          <kin-icon name="gps_stroke" color="#7E8184" [size]="16" />
          <label>{{ 'content_creation_preview.synchronization' | translate }}</label>

          <p class="value" style="flex: 2" [style]="{ color: syncroStatusColor }">
            {{
              mediaBlockService.syncroStatus()
                ? '• ' +
                  ('content_creation_preview.syncro_status.' + mediaBlockService.syncroStatus()
                    | translate)
                : '-'
            }}
          </p>
          <kin-icon
            name="information"
            color="#428FF3"
            [size]="16"
            [tooltip]="'content_creation_preview.syncro_status.tooltip' | translate"
            tooltipPosition="top"
          />
        </li>
      }

      <li>
        <kin-icon name="eye_on" color="#7E8184" [size]="16" />
        <label>{{ 'content_creation_preview.visibility' | translate }}</label>
        <p class="value">
          @if (visibilityLabelKey(); as labelKey) {
            {{ labelKey | translate | upperFirstLetter }}
          } @else {
            -
          }
        </p>
      </li>
      <li>
        @if (mode() === 'creation') {
          <kin-icon name="watts_stroke" color="#7E8184" [size]="16" />
          <label>{{ 'content_creation_preview.desired_publication' | translate }}</label>
          <p class="value">
            @if (preview().planningType) {
              {{ 'publication_block.planning.' + preview().planningType | translate }}
            } @else {
              -
            }
          </p>
        } @else {
          <kin-icon name="watts_stroke" color="#7E8184" [size]="16" />
          <label>{{ 'content_creation_preview.publication_date' | translate }}</label>
          <p class="value">
            @if (preview().planningType) {
              {{ 'publication_block.planning.' + preview().planningType | translate }}
            } @else {
              -
            }
          </p>
        }
      </li>
    </ul>
  }
</header>

@if (showFooter()) {
  <footer>
    @if (mode() === 'creation') {
      <button class="cta-primary" [disabled]="!previewContentType()" (click)="sendContent()">
        {{ (isEditing() ? 'common.save' : 'content_creation_preview.send_content') | translate }}
      </button>
    } @else {
      <button class="cta-secondary stroke" (click)="viewOnKinomapClick()">
        {{ 'content_creation_preview.view_on_website' | translate }}
        <kin-icon name="external" [color]="colorsService.brandSecondary()" [size]="24" />
      </button>
    }
  </footer>
}
